import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconHabitsTracker = props => {
  const { rootClassName, className, pencilClassName } = props;
  const classes = classNames(rootClassName || root, className);
  return (
    <svg width="20" height="20" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="14" width="44" height="40" rx="4" stroke="#000" strokeWidth="3" />

      <line x1="20" y1="10" x2="20" y2="20" stroke="#000" strokeWidth="3" strokeLinecap="round" />
      <line x1="44" y1="10" x2="44" y2="20" stroke="#000" strokeWidth="3" strokeLinecap="round" />

      <rect x="18" y="24" width="28" height="24" rx="2" stroke="#000" strokeWidth="2" />

      <path
        d="M22 32 L25 35 L30 29"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="32" y1="32" x2="42" y2="32" stroke="#000" strokeWidth="2" strokeLinecap="round" />

      <path
        d="M22 40 L25 43 L30 37"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="32" y1="40" x2="42" y2="40" stroke="#000" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

IconHabitsTracker.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconHabitsTracker.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconHabitsTracker;
